import React from 'react';
import { Overlay, Spinner } from '@flixbus/honeycomb-react';
import { useTranslation } from 'react-i18next';
import { useLoading } from '../../contexts/LoadingContext';

const Loader = () => {
    const { t } = useTranslation();
    const { loading } = useLoading();

    if (!loading) return null;

    return (
        <Overlay
            extraClasses="loader"
            role="status"
            aria-label={t('titles.loading')}
            aria-busy="true"
            aria-live="polite"
        >
            <Spinner size="xl" extraClasses="loader__spinner" />
        </Overlay>
    );
};

export default Loader;
